import { GeoJSON } from "geojson";

export interface IRagScore {
  Level: number;
  Description: string;
  Color: string;
}

export enum ERiskSummaryType {
  Default,
  JBA,
  FloodClimateChange,
}
export interface IRiskSummary {
  Score: number;
  RAGScore: IRagScore;

  NumberOfAreas?: number;
  NoBuildings?: number;
  NoCDPs?: number;
  NoRDPs?: number;
}

export interface IRiskAccuracy {
  BufferMeters?: number;
  Level: string;
  BufferType: "square" | "round";
  Description: string;
  ZoomstackBuilding?: string;
  BuildingGeom?: GeoJSON.Feature<GeoJSON.Geometry>;
}

export interface IJbaScoreCount {
  Score: number;
  NonDefendedScore: number;
  Layer: {
    Name: string;
    Year: number;
  };
  Defended: boolean;
  BandScore: number;
  BandDepth: string;
  LayerString: string;
}

export interface FloodClimateChangeScores {
  CombinedScoreCoastal: number;
  CombinedScoreRiver: number;
  CombinedScoreSurfaceWater: number;
}

export interface IJbaRiskSummary extends IRiskSummary {
  Period: string;
  JBACombinedRisk: IJBACombinedRisk;
  JBAScoreCount: IJbaScoreCount[];
}

export interface IJBACombinedRisk {
  CombinedScore: number;
  RAGScore: IRagScore;
  CombinedScoreRiver?: number;
  CombinedScoreSurfaceWater?: number;
  CombinedScoreCoastal?: number;
}

export interface IRiskRecord {
  RiskSummary: IRiskSummary | IJbaRiskSummary;
  Accuracy: IRiskAccuracy;
  moreInfo?: string;
}

export interface RiskOverrides {
  name: string;
  options: RiskOverrideOption[];
  selectionDescription?: string;
}

export interface RiskOverrideOption {
  overrides: RiskOverride[];
}

export interface RiskOverride {
  riskLookupName: string;
  riskLookupKey: string;
  riskLookupValue: string;
}
